import { render } from "./index.vue?vue&type=template&id=46b37b9c&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Modules/Authentication/LogOut/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46b37b9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46b37b9c', __exports__)) {
    api.reload('46b37b9c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=46b37b9c&ts=true", () => {
    api.rerender('46b37b9c', render)
  })

}


export default __exports__